"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFragments = void 0;
const messaging_constants_1 = require("./messaging.constants");
/**
 * Count the number of fragments assuming that only GSM characters
 * are present in the message
 * @param charactersInSmsBody the number of characters in the message
 * @returns number of fragments for a text of length specified
 */
const calculateFragmentsWithGSMChars = (charactersInSmsBody) => charactersInSmsBody > 160 ? Math.ceil(charactersInSmsBody / 153.0) : 1;
/**
 * Count the number of fragments assuming that non-GSM unicode characters
 * are present in the message
 * @param charactersInSmsBody the number of characters in the message
 * @returns number of fragments for a text of length specified
 */
const calculateFragmentsWithUnicode = (charactersInSmsBody) => charactersInSmsBody > 70 ? Math.ceil(charactersInSmsBody / 66.0) : 1;
/**
 * @deprecated use `calculateSMSFragments()` instead
 *
 * calculates the number of fragments for a given text.
 * It looks at the characters contained in the text and then calls the appropriate
 * method for counting the fragments.
 * On the backend, we replace some unicode
 * characters with an established GSM replacement as a cost-saving
 * strategy for our users. This means that the actual number of characters and
 * fragments sent might be different but this is considered fine for now as we are
 * potentially sending less than we might say on the client.
 * This replacement is handled by the GsmSanitisedMessage class
 * https://github.com/Accurx/rosemary/blob/trunk/src/Shared/accuRx.Shared/Classes/SmsCharacterResult.cs#L125
 * @param smsBody The body of the message for which we want to calculate fragments
 * @returns number of fragments that will be sent
 */
const calculateFragments = (smsBody) => {
    const smsCharacters = smsBody.split("");
    /**
     * check if message will be sent as unicode.
     * If the message contains any characters not
     * contained in the list of allowed GSM characters
     * (for both characters that are counted as single and
     * double) then we will consider it to be using Unicode.
     */
    const usingUnicode = smsCharacters.some((character) => !messaging_constants_1.GSM_CHARSET.includes(character) &&
        !messaging_constants_1.GSM_DOUBLE_CHARACTERS.includes(character));
    /**
     * Some characters are counted as two characters. Whenever
     * these are present, increase the count of the sum. However,
     * when we are using unicode, then all characters are counted as
     * double so there is no need to perform this calculation so we do
     * an early return of 0 meaning that the characters are counted as one
     * but `calculateFragmentsWithUnicode` reduces the characters per fragment
     */
    const countOfDoubleCharacters = usingUnicode
        ? 0
        : smsCharacters.reduce((sum, character) => messaging_constants_1.GSM_DOUBLE_CHARACTERS.includes(character) ? sum++ : sum, 0);
    /**
     * Total count is the actual number of characters in the
     * message plus the number of characters considered to be double
     */
    const smsCharacterCount = smsBody.length + countOfDoubleCharacters;
    return usingUnicode
        ? calculateFragmentsWithUnicode(smsCharacterCount)
        : calculateFragmentsWithGSMChars(smsCharacterCount);
};
exports.calculateFragments = calculateFragments;
//# sourceMappingURL=fragments.js.map